import { render, staticRenderFns } from "./phoneApp.vue?vue&type=template&id=2ff267ae&scoped=true"
import script from "./phoneApp.vue?vue&type=script&lang=js"
export * from "./phoneApp.vue?vue&type=script&lang=js"
import style0 from "./phoneApp.vue?vue&type=style&index=0&id=2ff267ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff267ae",
  null
  
)

export default component.exports